import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const DnPreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '2px',
            sm: 'var(--border-radius-sm)',
            md: 'var(--border-radius-md)',
            lg: 'var(--border-radius-lg)',
            xl: 'var(--border-radius-xl)',
        },
        slate: {
            50: 'var(--color-gray-100)',
            100: 'var(--color-gray-100)',
            200: 'var(--color-gray-200)',
            300: 'var(--color-gray-300)',
            400: 'var(--color-gray-400)',
            500: 'var(--color-gray-500)',
            600: 'var(--color-gray-600)',
            700: 'var(--color-gray-700)',
            800: 'var(--color-gray-800)',
            900: 'var(--color-gray-900)',
            950: 'var(--color-darkest)',
        }
    },
    semantic: {
        transitionDuration: 'var(--transition-timing-fast)',
        primary: {
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.200}',
            300: '{slate.300}',
            400: '{slate.400}',
            500: '{slate.500}',
            600: '{slate.600}',
            700: '{slate.700}',
            800: '{slate.800}',
            900: '{slate.900}',
            950: '{slate.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: 'var(--color-lightest)',
                },
                formField: {
                    shadow: 'var(--box-shadow-light)',
                },
                content: {
                    borderRadius: 'var(--border-radius-md)',
                }
            }
        }
    },
});

export default {
    preset: DnPreset,
    options: {
        darkModeSelector: false,
        mergeSections: true,
        cssLayer: {
            name: 'dn-primevue',
            order: 'reset, dn-primevue'
        },
    }
};

